<gc-picture-gallery-slider
  [title]="title()"
  [pictures]="pictures()"
  [selected]="selected"
  [showLoading]="loading()"
  (save)="onSave($event)"
  (doClose)="onClose()" />
